<template>
    <div layout="column" layout-align="center center" class="login-container" flex>
        <div layout="column" layout-align="center center" class="width-100-mobile" flex>
            <div layout="row" layout-align="center center" class="hidden-sm-and-down">
                <img src="@/assets/logo.png" style="max-height: 300px; position: relative; top: -30px; background: white">
            </div>
            <v-card class="login-card mb-5" flat>
                <v-card-text layout="column">
                    <v-form @submit.prevent="check" layout="column" class="mx5-pc">
                        <div class="title secondary--text font-weight-medium text-uppercase my-4">{{$t("login.reset_title")}}</div>
                        <v-subheader class="pl-0">{{$t("login.code_info")}}</v-subheader>
                        <v-text-field outline :label="$t('login.code')" single-line flex v-model="form.code" required></v-text-field>
                    </v-form>
                </v-card-text>

                <v-card-actions layout="row" layout-align="end center" class="mx5-pc mr2-mobile mb-3">
                    <router-link href="#" class="black--text mr-3" :to="{name: 'login'}">{{$t("login.back")}}</router-link>
                    <v-btn depressed color="primary" large @click="check">{{$t("_.validate")}}</v-btn>
                </v-card-actions>
            </v-card>
            <div class="hidden-sm-and-down upper-relative full-width text-xs-center" style="background: white">
                {{$t("_.supported")}}
            </div>
            <div class="hidden-sm-and-down upper-relative" layout="row" layout-align="center center">
                <img src="@/assets/GOUV_MENJE.png" style="background: white" width="400">
            </div>
        </div>
    </div>
</template>
<script>
    import ResetPasswords from '~/api/reset-passwords'
    export default {
        data () {
            return {
                form: {
                    code: ''
                }
            }
        },
        methods: {
            check () {
                ResetPasswords.verifyCode(this.$route.params.id, this.form).then(res => {
                    this.$snotify.success(this.$t('login.correct'));
                    this.$router.push('/reset-password/' + res.data + '/reset');
                })
            }
        }
    }
</script>
<style scoped>
.login-card {
  width: 600px;
  background-color: rgba(241, 241, 241, 0.7);
}

.login-container {
  /*background: url('/home.png') no-repeat center center;*/
  background-size: cover;
  position: relative;
  padding-bottom: 50px;
}

.upper-relative {
  position: relative;
  top: -60px;
}

@media screen and (max-width: 960px) {
  .login-card {
    width: 100%;
  }

  .login-container {
    padding-bottom: 0px;
  }

  body,
  html {
    overflow: hidden;
  }
}
@media screen and (min-width: 960px) {
  .login-card {
    top: -60px;
  }
}
</style>